import { Tooltip, Button } from "antd";
import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { slideAction } from "../../store/slideSlice";
import presentIcon from "../../assets/presentIcon.svg";

export const Present = () => {
  const isMobile = window.screen.width < 768;
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 992);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const currentSlideId = useSelector((state) => state.slide.currentSlideId);
  const slides = useSelector((state) => state.slide.slides);
  const darkMode = useSelector((state) => state.slide.darkMode);

  const dispatch = useDispatch();
  const slideIds = useMemo(
    () => Object.keys(slides).filter((slideId) => !slideId.includes("master")),
    [slides]
  );

  let currentIndex = slideIds.indexOf(currentSlideId);

  function changeSlide(e) {
    if (e.key === "ArrowDown" || e.key === "ArrowRight") {
      dispatch(
        slideAction.setCurrentSlide(
          slideIds[currentIndex === slideIds.length - 1 ? slideIds.length - 1 : ++currentIndex]
        )
      );
    } else if (e.key === "ArrowUp" || e.key === "ArrowLeft") {
      dispatch(
        slideAction.setCurrentSlide(slideIds[currentIndex === 0 ? 0 : --currentIndex])
      );
    }
  }

  function exitHandler() {
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      let slideContainer = document.getElementById("slide01");
      slideContainer?.classList.remove("zoom");
      document.removeEventListener("keydown", changeSlide, false);
      dispatch(slideAction.setPresentMode(false));
      document.removeEventListener("fullscreenchange", exitHandler, false);
      document.removeEventListener("mozfullscreenchange", exitHandler, false);
      document.removeEventListener("MSFullscreenChange", exitHandler, false);
      document.removeEventListener("webkitfullscreenchange", exitHandler, false);
    }
  }

  function handleButtonClick() {
    if (isSmallScreen) return; // Prevent action on small screens

    let element = document.getElementById("slide01");
    if (element) {
      element.classList.add("zoom");
      element.requestFullscreen().then(() => {
        document.addEventListener("keydown", changeSlide, false);
        element.childNodes.forEach((ele) => {
          ele.classList.contains("border") && ele.classList.remove("border");
          ele.classList.contains("selected") && ele.classList.remove("selected");
        });
        dispatch(slideAction.setPresentMode(true));

        document.addEventListener("fullscreenchange", exitHandler, false);
        document.addEventListener("mozfullscreenchange", exitHandler, false);
        document.addEventListener("MSFullscreenChange", exitHandler, false);
        document.addEventListener("webkitfullscreenchange", exitHandler, false);
      });

      const toolbar = document.getElementById("quillToolbar")?.firstElementChild;
      toolbar && toolbar.remove();
    }
  }

  return (
    <Tooltip
      title={isSmallScreen ? "Present is available on bigger screens only" : ""}
      placement="bottom"
    >
      <Button
        style={{
          width: isMobile ? "70px" : "100px",
          height: "30px",
          textAlign: "center",
          lineHeight: 0.8,
          verticalAlign: "center",
          color: "#0f0f0a",
          opacity: isSmallScreen ? 0.5 : 1,
          cursor: isSmallScreen ? "not-allowed" : "pointer",
        }}
        onClick={handleButtonClick}
        disabled={isSmallScreen}
      >
        <span
          style={{
            fontSize: isMobile ? "10px" : "12px",
            fontWeight: 500,
            letterSpacing: 0.5,
            marginLeft: isMobile ? -8 : "",
            paddingRight: "5px",
          }}
        >
          Present
        </span>
        <span className="present-icon">
          <img
            width={"16px"}
            height={"20px"}
            src={presentIcon}
            style={{ filter: darkMode ? "none" : "invert(85%)" }}
            alt="..."
          />
        </span>
      </Button>
    </Tooltip>
  );
};